module.exports = __webpack_public_path__ + "img/19.32f09cfd.gif";